import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  descriptionText: {
    fontSize: 16.6,
    lineHeight: 25,
    marginTop: 16.6,
  },
  showText: theme => ({
    fontSize: 16.6,
    marginTop: 12.5,
    color: theme.colors.showMoreColor,
    textAlign: 'center',
  }),
  showMoreText: numberOfLines => ({
    marginTop: numberOfLines === 0 ? 0 : 12.5,
  }),
});
